import { useCallback } from "react";
import "../../../newComponents/listings/top-listing-headers/top-listing-headers.css";
import SearchFilterInput from "../../../newComponents/form-fields/search-filter-input";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import H2 from "../../../newComponents/typography/H2";
import SingleDropdown from "../../../newComponents/singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface PayeeAccountsTopHeaderProps {
  className?: string;
  PageHeading?: string;
  Count?: number;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  activeFilter: string;
  handleFilterChange: (filter: string) => void;
  filterOptions?: { title: string; count: number }[];
}

export default function PayeeAccountsTopHeader({
  className = "",
  PageHeading,
  Count,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  activeFilter,
  handleFilterChange,
  filterOptions = [],
}: PayeeAccountsTopHeaderProps) {
  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, [setSearchTerm]);

  return (
    <div className={`top-listing-header payee-accounts-header ${className}`}>
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={PageHeading || ""} />
        </div>

        <div className="top-listing-header-right">
          <div className="payment-header-actions">
            <SearchFilterInput
              placeholder="Search By Payee Account"
              searchTerm={searchTerm}
              handleSearch={handleSearch}
            />

            <div className="filters-mobile">
              <SingleDropdown
                triggerText={activeFilter}
                triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
                triggerIconPosition="right"
                menuItems={filterOptions.map((option) => ({
                  label: `${option.title} (${option.count})`,
                  action: () => handleFilterChange(option.title),
                }))}
              />
            </div>

            {ButtonName && (
              <SimpleButton
                className="top-listing-header-button-desktop"
                label={ButtonName}
                onClick={onClick}
              />
            )}
            {(MobileButtonName || ButtonName) && (
              <SimpleButton
                className="top-listing-header-button-mobile"
                label={MobileButtonName || ButtonName}
                onClick={onClick}
              />
            )}
          </div>
        </div>
      </div>

      <div className="top-listing-header-filters top-listing-header-filters--pills">
        <div className="filter-options filters-desktop filter-options--pills">
          {filterOptions.map((option) => (
            <button
              key={option.title}
              className={`filter-option ${activeFilter === option.title ? "filter-option-active" : ""}`}
              onClick={() => handleFilterChange(option.title)}
            >
              {option.title} ({option.count})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
